import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Avatar, colors } from 'kangarootime-ui';
import { Fade } from '@material-ui/core';
import './styles.css';

const EmployeeCell = ({
  name,
  photo,
  timeframe,
  groupColor,
  shiftDuration,
  weeklyHours,
  selectShift,
  isSelected,
  isDraft,
  isToBeRemoved,
  ...props
}) => {
  return (
    <Fade in>
      <div
        className='week-overview-employee-cell-container'
        style={{
          border: isSelected && `2px solid ${colors.brand_3}`,
          backgroundColor: isDraft ? colors.info_background : isToBeRemoved ? colors.danger_background : ''
        }}
        onClick={selectShift}
      >
        { name &&
          <div className='flex-rows' style={{ padding: '0 8px', height: '100%', borderLeft: groupColor && `2px solid ${groupColor}` }}>
            <div className='flex-columns' style={{ justifyContent: 'center' }}>
              <Avatar size='sm' image={photo} />
            </div>
            <div className='flex-columns flex-1' style={{ marginLeft: 8, justifyContent: 'center' }}>
              <Typography style={{ fontSize: '0.75rem', fontWeight: 500, lineHeight: 'normal', whiteSpace: 'nowrap' }}>{name}</Typography>
              <Typography style={{ fontSize: '0.625rem', color: groupColor, lineHeight: 'normal', whiteSpace: 'nowrap' }}>{timeframe}</Typography>
            </div>
            <div className='flex-columns' style={{ marginLeft: 8, justifyContent: 'center', alignItems: 'flex-end' }}>
              { shiftDuration && <Typography style={{ fontSize: '0.75rem', fontWeight: 500, lineHeight: 'normal', whiteSpace: 'nowrap' }}>Shift: {shiftDuration} hrs</Typography> }
              { weeklyHours && <Typography style={{ fontSize: '0.625rem', color: colors.brand_4, lineHeight: 'normal', whiteSpace: 'nowrap' }}>Week Total: {weeklyHours} hrs</Typography> }
            </div>
          </div>
        }
      </div>
    </Fade>
  );
};

EmployeeCell.propTypes = {
  name: PropTypes.string,
  photo: PropTypes.string,
  timeframe: PropTypes.string,
  groupColor: PropTypes.string,
  shiftDuration: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
  weeklyHours: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
  selectShift: PropTypes.func,
  isSelected: PropTypes.bool,
  isDraft: PropTypes.bool // shift been created on the front end but not saved on the backend
};

export default React.memo(EmployeeCell, (prevProps, nextProps) => (
  prevProps.name === nextProps.name &&
  prevProps.photo === nextProps.photo &&
  prevProps.timeframe === nextProps.timeframe &&
  prevProps.shiftDuration === nextProps.shiftDuration &&
  prevProps.weeklyHours === nextProps.weeklyHours &&
  prevProps.isSelected === nextProps.isSelected &&
  prevProps.isDraft === nextProps.isDraft
));
